import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = { class: "data-item__header" };
const _hoisted_2 = { class: "data-item__topic" };
const _hoisted_3 = { class: "data-item__title" };
const _hoisted_4 = { class: "data-item__actions" };
const _hoisted_5 = { class: "data-item__content" };
const _hoisted_6 = {
    key: 0,
    class: "data-item__section"
};
import { onMounted, ref } from 'vue';
import { useRoute, useRouter } from "vue-router";
import customerRepository from '@astina/paloma-shop-common-ui/src/services/CustomerRepository';
import Spinner from "@astina/paloma-common-ui/src/components/Spinner.vue";
import AppForm from "@astina/paloma-common-ui/src/components/form/AppForm.vue";
import { saveUser } from "../commands/SaveUser";
import ValidationUtils from "@astina/paloma-common-ui/src/services/ValidationUtils";
import RouterUtils from "@astina/paloma-common-ui/src/util/RouterUtils";
export default /*@__PURE__*/ _defineComponent({
    __name: 'UserEditView',
    setup(__props) {
        const route = useRoute();
        const router = useRouter();
        const user = ref(null);
        const draft = ref(null);
        const form = ref(null);
        const validation = ref(ValidationUtils.emptyValidation());
        onMounted(() => {
            const userId = RouterUtils.singleParam(route, 'id');
            customerRepository.getUser(userId).then(userParam => {
                user.value = userParam;
                draft.value = createDraft(userParam);
            });
            customerRepository.getUserForm().then(formParam => {
                form.value = formParam;
            });
        });
        function save() {
            saveUser(draft.value)
                .then(() => {
                router.push({ name: 'config_users_user', params: { id: user.value.id } });
            })
                .catch(validationParam => {
                validation.value = validationParam;
            });
        }
        function cancel() {
            router.push({ name: 'config_users_user', params: { id: user.value.id } });
        }
        function createDraft(user) {
            return {
                id: user.id,
                emailAddress: user.emailAddress,
                firstName: user.firstName,
                lastName: user.lastName,
                enabled: user.enabled,
                gender: user.gender,
                locale: user.locale,
                roles: user.roles.map(r => r.name),
            };
        }
        return (_ctx, _cache) => {
            const _component_router_link = _resolveComponent("router-link");
            return (_openBlock(), _createElementBlock("div", {
                class: _normalizeClass(["data-item user", { 'user--loading': !user.value }])
            }, [
                _createElementVNode("header", _hoisted_1, [
                    (user.value)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            _createElementVNode("h2", _hoisted_2, _toDisplayString(_ctx.$t('user.edit')), 1),
                            _cache[0] || (_cache[0] = _createTextVNode()),
                            _createElementVNode("h1", _hoisted_3, _toDisplayString(((user.value.firstName || '') + ' ' + (user.value.lastName || '')).trim() || user.value.username), 1),
                            _cache[1] || (_cache[1] = _createTextVNode()),
                            _createElementVNode("div", _hoisted_4, [
                                _createVNode(_component_router_link, {
                                    to: { name: 'config_users_user', params: { id: user.value.id } },
                                    class: "button button--outline"
                                }, {
                                    default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(_ctx.$t('cancel')), 1)
                                    ]),
                                    _: 1
                                }, 8, ["to"])
                            ])
                        ], 64))
                        : (_openBlock(), _createBlock(Spinner, {
                            key: 1,
                            loading: !user.value || !form.value
                        }, null, 8, ["loading"]))
                ]),
                _cache[2] || (_cache[2] = _createTextVNode()),
                _createElementVNode("div", _hoisted_5, [
                    (user.value && form.value)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                            _createVNode(AppForm, {
                                form: form.value,
                                data: draft.value,
                                validation: validation.value,
                                onSubmit: save,
                                onCancel: cancel,
                                "submit-icon": "save",
                                "submit-label": _ctx.$t('save')
                            }, null, 8, ["form", "data", "validation", "submit-label"])
                        ]))
                        : _createCommentVNode("", true)
                ])
            ], 2));
        };
    }
});
